import SpinBox from "./SpinBox";

export default SpinBox;